import React from "react";
import page_not_found from "../images/page_not_found.svg";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

export default function Default({}) {
  return (
    <Grid container>
      <Grid item sm={2} xs={false}></Grid>
      <Grid
        item
        container
        direction="column"
        alignItems="center"
        sm={8}
        xs={12}
      >
        <div className={"header-space"}></div>
        <img
          style={{
            height: "40vh",
            maxWidth: "90vw",
            objectFit: "contain",
            margin: "1rem 0",
          }}
          src={page_not_found}
          alt=""
        />
        <Typography variant="h6" style={{ color: "gray" }}>
          Page Not Found
        </Typography>
        <div className={"footer-space"}></div>
      </Grid>
      <Grid item sm={2} xs={false}></Grid>
    </Grid>
  );
}
